var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('div',[(_vm.rsettings[0].settings.photo)?_c('img',{attrs:{"src":_vm.record.student.passport,"height":"70px"}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }